import { createElement } from 'react';

interface FormaCompassProps extends React.HTMLAttributes<HTMLElement> {
	angle?: number;
}

export function FormaCompass({ className, angle = 0, ...rest }: FormaCompassProps) {
	return createElement('forma-compass', {
		className,
		angle,
		...rest,
	});
}
